export default "__VITE_ASSET__CPGKUhl7__"